
import { Component, Vue } from "vue-property-decorator";
import { uiStore } from "@/store/store";

import {
  getNodeElementWrapperStyles,
  getDomElementFromTreeNode,
  getNodeTitlebarStyles
} from "@/lib/canvas/helpers";
import { forceNextTick } from "@/util/force-next-tick";
import Icon from "@/components/UI/Icon.vue";
import { getElementName } from "@/lib/elements/utils";
import EditElementCanvasButton from "./components/EditElementCanvasButton.vue";
import {
  SECTION_SLUG,
  DIV_SLUG,
  COLUMNS_SLUG,
  COLUMN_SLUG
} from "@/lib/elements/constants";

@Component({
  components: {
    Icon,

    EditElementCanvasButton
  }
})
export default class NodeTitlebar extends Vue {
  interval!: NodeJS.Timer;
  refreshRate = 500;

  nonEditableElementsSlugs = [DIV_SLUG, COLUMNS_SLUG, COLUMN_SLUG];

  get shouldShowTitlebar() {
    if (!uiStore.activeElement) return false;

    const element = uiStore.activeElement;
    return (
      !uiStore.elementWithContentEditable &&
      !this.nonEditableElementsSlugs.includes(element.data.type)
    );
  }

  unsubscribeFromStorePositionWrapper = () => {};
  nextTickPositionsWrapper() {
    forceNextTick(this.calculateStylesAndTitle);
  }

  mounted() {
    this.calculateStylesAndTitle();

    this.unsubscribeFromStorePositionWrapper = this.$store.subscribe(
      this.nextTickPositionsWrapper
    );

    window.addEventListener("resize", this.nextTickPositionsWrapper);

    this.interval = setInterval(
      this.nextTickPositionsWrapper,
      this.refreshRate
    );
  }

  beforeDestroy() {
    this.unsubscribeFromStorePositionWrapper();

    window.removeEventListener("resize", this.nextTickPositionsWrapper);

    clearInterval(this.interval);
  }

  titlebarPositionStyle: { [key: string]: string } = {};

  wrapperPositionStyle: { [key: string]: string } = {
    display: "none"
  };

  elementTitle = "";

  // Everything is calculated in a func to avoid UI flicker caused by values being calculated at different times
  calculateStylesAndTitle() {
    if (uiStore.elementWithContentEditable || !this.element) {
      this.wrapperPositionStyle = {
        display: "none"
      };

      return;
    }

    this.elementTitle = this.getElementTitle();

    this.wrapperPositionStyle = getNodeElementWrapperStyles(
      getDomElementFromTreeNode(this.element)
    );

    this.titlebarPositionStyle = getNodeTitlebarStyles(this.element);
  }

  get titlebarClasses() {
    return {
      "node-titlebar-is-offset": !!this.wrapperPositionStyle.outlineOffset,
      "is-hidden": !this.shouldShowTitlebar
    };
  }

  //   get shouldShowTitlebar() {}

  get element() {
    return uiStore.activeElement;
  }

  get elementId() {
    return uiStore.activeElementId;
  }

  getElementTitle() {
    if (!this.element) return "";
    return getElementName(this.element);
  }

  get isSectionElement() {
    return this.element && this.element.data.type === SECTION_SLUG;
  }

  get node() {
    // False should never happen
    return this.element || false;
  }
}
